import React from 'react';
import { FileViewLoader } from '../../../VentoryUI/components/common/File';
import { TranslationKey } from '../../../types/translation/TranslationKey';
import { t } from '../../../types/translation/Translator';
import { FileEntityType } from '../../../types/file';

interface ImagesPreviewsGridProps {
  cfImageValue: string | null | undefined;
  attachedImages: string[];
  handleRemove: (id: string) => void;
  fileEntityType: FileEntityType;

  disabled: boolean;
}

export default function ImagesPreviewsGrid({
  cfImageValue,
  attachedImages,
  handleRemove,
  disabled,
  fileEntityType,
}: ImagesPreviewsGridProps) {
  return (
    <div className='mt-2 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4'>
      {cfImageValue &&
        attachedImages?.length > 0 &&
        attachedImages.map(id => (
          <div key={id} className='relative mb-24 flex h-48 w-48 flex-col items-center p-4'>
            {!disabled ? (
              <button
                type='button'
                className='absolute right-1 top-1 rounded-full bg-white bg-opacity-100 p-1 shadow transition hover:bg-red-500 hover:text-white'
                onClick={() => (disabled ? null : handleRemove(id))}
                aria-label={t(TranslationKey.fileUploadRemoveFile).singular.label}
              >
                <svg width='16' height='16' fill='none' viewBox='0 0 16 16'>
                  <path stroke='currentColor' strokeWidth='2' strokeLinecap='round' d='M4 4l8 8M12 4l-8 8' />
                </svg>
              </button>
            ) : null}
            <FileViewLoader fileEntityType={fileEntityType} fileId={id} className='w-40 object-cover' preview={true} />
          </div>
        ))}
    </div>
  );
}
